class TeamPitcherModel {
    constructor (data) {
        this.data = data;
        this.isDataLoaded = true;
        if (data) {
            this.hasData = true
        }
    }
}

export default TeamPitcherModel;
